export default __webpack_public_path__ + "static/media/greenspacedestbase_trans.28718e06.png";